import { useSearchParams } from 'react-router-dom';
import { DisciplinePage } from '../../../shared/components/DisciplinePage';
import { OrganigramaPage } from './OrganigramaPage';
import { OrganizacionesPage } from '../organizations/pages/OrganizacionesPage';
import { PersonasPage } from '../people/pages/PersonasPage';
import { GobernanzaPage } from './GobernanzaPage';
import { PeopleAnalyticsDashboard } from '../analytics/pages/PeopleAnalyticsDashboard';
import { MadurezDashboard } from '../maturity/pages/MadurezDashboard';
import { PuestosListPage } from '../positions/pages/PuestosListPage';
import { StructureAdminPage } from '../admin/pages/StructureAdminPage';
import { DepartamentosArbol } from '../organizations/components/DepartamentosArbol';
import { useI18n } from '../../../../i18n';
import { useHasNivelModulo } from '../../../../hooks/useModuloAcceso';

export function StructurePage() {
  const { t } = useI18n();
  // 0613 ADR-024: tab Administracion visible para nivel ADMIN en M1.
  // Cubre admins globales (cortocircuito implicito) + MEMBERs designados
  // como admin de Structure via UsuarioModuloAcceso.
  const canAdminStructure = useHasNivelModulo('M1', 'ADMIN');
  const [searchParams, setSearchParams] = useSearchParams();
  const focusPuesto = searchParams.get('focusPuesto') ?? undefined;

  // Only clear focusPuesto — tab is persisted by DisciplinePage
  if (focusPuesto) {
    setTimeout(() => {
      const current = Object.fromEntries(searchParams.entries());
      delete current.focusPuesto;
      setSearchParams(current, { replace: true });
    }, 100);
  }

  const tabs = [
    {
      key: 'analytics',
      label: (t.structure as any).tabs?.analytics ?? 'Analytics',
      component: <PeopleAnalyticsDashboard embedded />,
    },
    {
      key: 'organigrama',
      label: t.structure.tabs.orgChart,
      component: <OrganigramaPage embedded focusPuesto={focusPuesto} />,
    },
    {
      key: 'puestos',
      label: (t.structure as any)?.tabs?.positions ?? 'Puestos',
      component: <PuestosListPage embedded />,
    },
    {
      key: 'organizaciones',
      label: t.structure.tabs.organizations,
      component: <OrganizacionesPage embedded />,
    },
    {
      key: 'departamentos',
      label: (t.structure as any)?.tabs?.departments ?? 'Departamentos',
      component: <DepartamentosArbol />,
    },
    { key: 'personas', label: t.structure.tabs.people, component: <PersonasPage embedded /> },
    {
      key: 'gobernanza',
      label: t.structure.tabs.governance,
      component: <GobernanzaPage embedded />,
    },
    {
      key: 'madurez',
      label: (t.structure as any)?.tabs?.madurez ?? 'Madurez',
      component: <MadurezDashboard embedded />,
    },
    canAdminStructure
      ? {
          key: 'administracion',
          label: (t.structure as any)?.tabs?.admin ?? 'Administracion',
          component: <StructureAdminPage embedded />,
        }
      : null,
  ].filter(Boolean) as { key: string; label: string; component: React.ReactNode }[];

  return (
    <DisciplinePage
      accentColor="#0E243E"
      tabs={tabs}
      disciplineKey="structure"
      disciplineTitle={t.sidebar.pageTitle.structure}
    />
  );
}
